// Hook partagé Commercial : fetch /api/metier/hub-grids/pipeline-conversion
// avec auth Bearer + cookie + X-Tenant-ID dynamique.
import { useEffect, useState } from "react";
import { tenantResolu } from "../../utils/tenantResolu";
import { enteteTenant } from "../../utils/enteteTenant";

const API = process.env.REACT_APP_BACKEND_URL;

const getTenant = tenantResolu;

export function useCommercialFetch(url = "/api/metier/hub-grids/pipeline-conversion", deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    // Sans tenant résolu : AUCUNE requête, état vide explicite (jamais de repli sur un tenant nommé).
    const tenant = getTenant();
    if (!tenant) { setData(null); setError(null); setLoading(false); return () => { cancelled = true; }; }
    const token = localStorage.getItem("session_token");
    const headers = {
      ...enteteTenant(tenant),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    fetch(`${API}${url}`, { headers, credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`)))
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(String(e.message || e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps);

  return { data, loading, error };
}

export const FUNNEL_COLORS = [
  "var(--oh-stat-blue-text)", "#6366F1", "#8B5CF6",
  "var(--oh-stat-purple-text)", "#10B981", "var(--oh-stat-green-text)",
];
